// extracted by mini-css-extract-plugin
export default {"smallViews":"SmallViews_smallViews__8Hvxe"};